<script lang="ts">
    import { onMount } from "svelte";
    import { Link, useNavigate } from "svelte-navigator";
    import { ApiClient } from "../../../../GlobalHelper/ApiClient";
    import { user } from "../../../../store/stores";
    import { usersStore } from "../../../../store/users";
    import Pagination from "./Components/Pagination.svelte";
    import UserCard from "./Components/UserCard.svelte";

    const navigate = useNavigate();

    const getUsers = async () => {
        await $user.updateToken().then(async () => {
            await ApiClient.getInstance($user)
                .userClient.listUsers({ size: 17 })
                .then((users) =>
                    usersStore.update((usersStore) => {
                        return {
                            ...usersStore,
                            users: users,
                        };
                    })
                );
        });
    };

    onMount(() => getUsers());
</script>

<div class="columns is-multiline">
    <div class="column is-12">
        <div class="card sticky">
            <div class="card-content">
                <div class="content">
                    <div class="columns is-vcentered is-multiline">
                        <div class="column is-2">
                            <p
                                class="is-5 greenish-plus"
                                on:click={() => navigate("new")}
                            >
                                +
                            </p>
                        </div>
                        <div class="column is-3 ">
                            <p class="is-5 greenish">Nutzername</p>
                        </div>
                        <div class="column is-3 ">
                            <p class="greenish is-5">Vorname</p>
                        </div>
                        <div class="column is-3">
                            <p class="greenish is-5">Nachname</p>
                        </div>
                        {#if $usersStore.users && $usersStore.users.entries}
                            {#each $usersStore.users.entries as user}
                                <UserCard userEntry={user} />
                            {/each}
                        {/if}
                        {#if $usersStore.users && $usersStore.users.entries}
                            <Pagination />
                        {/if}
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

<style>
    .sticky {
        position: sticky;
        top: 0rem;
        z-index: 100;
    }

    .column {
        text-align: center;
    }

    .card {
        border-radius: 100px;
        padding: 1rem;
        padding-bottom: 0;
    }

    .greenish {
        background-color: #14acab;
        border-radius: 40px;
        color: white;
        height: 50px;
        margin: 0 11px;
        padding: 13px;
    }

    .greenish-plus {
        background-color: #14acab;
        border-radius: 40px;
        color: white;
        height: 50px;
        width: 50px;
        margin: auto;
        padding: 13px;
        font-size: 2rem;
        font-weight: 600;
        line-height: 25px;
    }

    .greenish-plus:hover {
        cursor: pointer;
    }
</style>
